module.exports = __webpack_public_path__ + "static/media/linkedin-circle.11a4fd22.svg";